import { fromJsonString, getFullUrl } from "@nuskin/ns-common-lib";

/**
 * Takes an amount and an optional unit and returns a string with the unit
 * @param {string | number} str
 * @param {string} unit
 */
export function convertToUnit(str, unit = "px") {
  if (str == null || str === "") {
    return undefined;
  } else if (isNaN(+str)) {
    return String(str);
  } else {
    return `${Number(str)}${unit}`;
  }
}

export function getImagesFromJson(siteUrl, val) {
  return fromJsonString(val, []).map(item => ({
    image: getFullUrl(siteUrl, item.image),
    alt: item.alt,
    link: item.link || "#",
    text: item.text,
    desc: item.desc
  }));

  // need to do Do we need to do this for size mapping?
  // sourceSizes: ImageService.getSizesString()
  // generateSrcSets() {
  //   this.localImageSrcs = this.localItems.map(item =>
  //     (item.image ? ImageService.createSRCSET(item.image, false) : "")
  //   );
  // }
}
